import {NAStart, NotificationAction} from "@dp-instant/social";
import {inject, injectable} from "inversify";
import {TypesGame} from "@game/TypesGame";
import {GameModel} from "@game/coregame/model/GameModel";
import {GenerateMapSpriteAction} from "@game/coregame/actions/GenerateMapSpriteAction";
import {Types2D} from "@dp-instant/interfaces";
import {loadTexture, RootView} from "@dp-instant/2d";
import {Container, Graphics, Sprite, Texture} from "pixi.js-legacy";

@injectable()
export class NAStartSIO extends NAStart {
    strategy = "IMMEDIATE";

    @inject(TypesGame.model)
    protected model: GameModel;

    @inject(Types2D.rootView)
    protected rootView: RootView;

    @inject(TypesGame.actions.createMap)
    protected createMapAction: GenerateMapSpriteAction;

    protected async getImage(): Promise<string> {
        const continent = this.model.currentContinent;
        if (continent) {
            const map = await this.createMapAction.run({
                activeStage: continent.stageLevel,
                data: continent.data
            });
            const image = new Container();

            const bg = new Graphics()
                .beginFill(0xd0d0d0)
                .drawRect(0, 0, NotificationAction.WIDTH_FULL, NotificationAction.HEIGHT_FULL);
            image.addChild(bg);

            const mapScale = this.aspectFactor(map.width, map.height, bg.width, bg.height);
            map.width *= mapScale;
            map.height *= mapScale;
            const avatar = await this.avatar(this.social.me.photo);
            avatar.height = NotificationAction.HEIGHT_FULL * 0.8;
            avatar.scale.x = avatar.scale.y;
            avatar.x = bg.width * 0.25;
            avatar.y = bg.height * 0.5;
            map.x = (bg.width - map.width) * 0.75;
            map.y = (bg.height - map.height) * 0.5;

            image.addChild(map, avatar);
            const base64Image = this.rootView.app.renderer.extract.base64(image);
            Texture.removeFromCache(map.texture);
            return base64Image;
        }
        return super.getImage();
    }
    protected aspectFactor(
        innerWidth: number,
        innerHeight: number,
        outerWidth: number,
        outerHeight: number
    ): number {
        const inner = innerWidth / innerHeight;
        const outer = outerWidth / outerHeight;
        return inner >= outer ? outerWidth / innerWidth : outerHeight / innerHeight;
    }
    protected async avatar(photo_url: string) {
        const R = 140;
        const greenStroke = new Graphics().lineStyle(40, 0x89db2f).drawCircle(0, 0, R);
        const mySprite = new Sprite(await loadTexture(photo_url));
        mySprite.anchor.set(0.5);

        const msk = new Graphics().beginFill(0).drawCircle(0, 0, R).endFill();
        const cont = new Container();
        cont.addChild(mySprite);
        cont.addChild(msk);
        mySprite.mask = msk;
        cont.addChild(greenStroke);
        Texture.removeFromCache(mySprite.texture);
        return cont;
    }
}
